module.exports = __webpack_public_path__ + "img/male.3129c9c7.svg";